import {text_field_change} from "../../redux/actions";
import React from "react";
import {useDispatch, useSelector} from "react-redux";

export const UserPhone = () => {
    const dispatch = useDispatch()
    const value = useSelector(state => state.app.requestUserPhone)
    const error = useSelector(state => state.app.requestUserPhoneError)
    return (
        <React.Fragment>
            <label className="request-popup__label" htmlFor="city_from">Номер телефона</label>
            <input type="tel"
                   id="user_phone"
                   className={'text-input phone-mask' + (error ? ' error' : '')}
                   name="user_phone"
                   placeholder=""
                   value={value}
                   onChange={(e) => dispatch(text_field_change('user_phone', e.target.value))}>
            </input>
        </React.Fragment>
    )
}